import styled from "styled-components";
import { Columns, Column, Heading } from "../../sdk/Layout";

export const Cols = styled(Columns)`
    @media (max-width: 768px) {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const Col = styled(Column)`
    ${(props) => props.is4 && "width: 33.333%; flex: none;"};
    ${(props) => props.is8 && "width: 66.666%; flex: none;"};

    @media (max-width: 768px) {
        ${(props) => props.is4 && "width: 50%; flex: none;"};
        ${(props) => props.is8 && "width: 100%; flex: none;"};
    }
`;

export const Text = styled(Column)`
    background-color: ${props => props.theme.white};
    padding: 50px;
    border-radius: 10px;
    height: 100%;
    p {
        margin: 0;
        padding: 0;
        font-size: 17px;
        color: ${props => props.theme.primaryDark};
        letter-spacing: 0;
        line-height: 30px;
        + p {
            margin-top: 15px;
        }
    }

    @media (max-width: 768px) {
        padding: 15px;
        & ${Heading} {
            padding-bottom: 10px;
        }
        P {
            font-size: 14px;
            line-height: 22px;
        }
    }
`;

export const Image = styled.figure`
    &:before {
        content: "";
        display: block;
        padding-top: 100%;
    }
    position: relative;
    img {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        max-width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;
    }
    ${(props) => props.medium && "width: 350px;"}
    ${(props) => props.right && "float: right;"}

	@media (max-width: 1215px) {
        ${(props) => props.medium && "width: 200px;"}
    }
    @media (max-width: 768px) {
        ${(props) => props.medium && "width: 143px;"}
    }
    @media (max-width: 520px) {
        ${(props) => props.medium && "width: 100%;"}
    }
`;

export const Follow = styled(Col)`
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    a {
        display: inline-block;
        vertical-align: middle;
        color: ${props => props.theme.gray};
        border: solid 1px ${props => props.theme.gray};
        width: 50px;
        height: 50px;
        line-height: 50px;
        border-radius: 50%;
        padding-top: 2px;
        transition: all 200ms linear;
        &:hover {
            background-color: white;
            border-color: #5f6061;
        }
        + a {
            margin-left: 5px;
        }
        svg {
            width: 16px;
            height: 16px;
        }
    }

    @media (max-width: 768px) and (min-width: 521px) {
        margin-top: -200px;
        align-items: flex-end;
    }

    @media (max-width: 520px) {
        width: 100%;
    }
`;
